import { render, staticRenderFns } from "./editOwnerCommitteeList.vue?vue&type=template&id=5a0a2632&scoped=true"
import script from "./editOwnerCommitteeList.vue?vue&type=script&lang=js"
export * from "./editOwnerCommitteeList.vue?vue&type=script&lang=js"
import style0 from "./editOwnerCommitteeList.vue?vue&type=style&index=0&id=5a0a2632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0a2632",
  null
  
)

export default component.exports